var React = require('react');

function ProgressInner (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.69995 6L7.66953 0.5H102.231L105.2 6L102.231 11.5H7.66953L4.69995 6Z","fill":"white"}));
}

ProgressInner.defaultProps = {"width":"110","height":"20","viewBox":"0 0 110 20","fill":"none"};

module.exports = ProgressInner;

ProgressInner.default = ProgressInner;
